module.exports = __webpack_public_path__ + "assets/img/dayu_course_start.72853f6d.png";